module.exports = __webpack_public_path__ + "img/sld_grid_ba1_dark.b7407830.svg";